import React from 'react'
import Style from './Footer.module.css'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from '../img/logo.png'
// import bloger from '../img/blogger.png'
import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <>
            <div className={ Style.main }>
                <div className={ Style.indiv }>
                    <Container>
                        <Row>
                            <Col sm={ 12 } xs={ 12 } lg={ 4 } md={ 12 }>
                                <h5 className={ Style.about }>COMPANY</h5><br />
                                <img src={ logo } alt="no-img" />
                            </Col>

                            <Col sm={ 12 } xs={ 12 } lg={ 4 } md={ 12 }>
                                <h5 className={ Style.about }>ABOUT US</h5><br />
                                Khodal Jari was incorporated in 2007 inspired by unique advantages of providing high quality of Metallic Yarn with the unique name of "Khodal Jari".

                                We believe in delivering valuable and dependable solutions based on high end technology in the benefit of the textile industry. Khodal Jari Committed to deliver the the best quality products, we give paramount importance to it. We feel proud to say that we are producing the most different colours in the whole world.
                            </Col>

                            <Col sm={ 12 } xs={ 12 } lg={ 2 } md={ 12 }>
                                <h5 className={ Style.about }>ADDRESS</h5><br />
                                <i class="fa-solid fa-location-dot"></i>
                                <p>1st & 2nd Floor Plot <br /> No.A-59, Nirmal Building, Malinivadi, Sandesh Press, A.k.Road.Surat-395008</p>
                            </Col>

                            <Col sm={ 12 } xs={ 12 } lg={ 2 } md={ 6 }>
                                <h5 className={ Style.about }> CONTACT NUMBER</h5><br />

                                <span className={ Style.contact }>
                                    <i class="fa-solid fa-user"><a href="tel:+91 9979696381">+91 99796 96381</a></i><br />
                                    <i class="fa-solid fa-user"><a href="tel:+91 9879468031">+91 98794 68031</a></i>
                                    <i class="fa-solid fa-user"><a href="tel:+91 9313696550">+91 93136 96550</a></i><br />
                                    {/* <a href="https://khodal.carrd.co/"> <img src={ bloger } alt="" /></a> */ }

                                        <a className={ Style.playstore } href="https://khodal.carrd.co/">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className={Style.icon} viewBox="0 0 512 512">
                                                <path d="M99.617 8.057a50.191 50.191 0 00-38.815-6.713l230.932 230.933 74.846-74.846L99.617 8.057zM32.139 20.116c-6.441 8.563-10.148 19.077-10.148 30.199v411.358c0 11.123 3.708 21.636 10.148 30.199l235.877-235.877L32.139 20.116zM464.261 212.087l-67.266-37.637-81.544 81.544 81.548 81.548 67.273-37.64c16.117-9.03 25.738-25.442 25.738-43.908s-9.621-34.877-25.749-43.907zM291.733 279.711L60.815 510.629c3.786.891 7.639 1.371 11.492 1.371a50.275 50.275 0 0027.31-8.07l266.965-149.372-74.849-74.847z"></path>
                                            </svg>
                                            <span className={Style.texts}>
                                                <span className={Style.text_1}>GET IT ON</span>
                                                <span className={Style.text_2}>Google Play</span>
                                            </span>
                                        </a>

                                </span>
                            </Col>
                        </Row>

                    </Container>

                </div>
            </div>
        </>
    )
}

export default Footer
